import { motion } from "framer-motion";
import { LineReveal } from "@/components/Reveal";

export default function PageHero({ overline, titleLines, subtitle, image, imageAlt, children }) {
  return (
    <section className="relative pt-40 pb-20 sm:pt-48 sm:pb-24 overflow-hidden bg-ink-950" data-testid="page-hero">
      {image && (
        <div className="absolute inset-0 z-0">
          <img src={image} alt={imageAlt || ""} className="w-full h-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink-950 via-ink-950/80 to-ink-950/50" />
        </div>
      )}
      <div className="absolute inset-0 z-[1] grid-lines opacity-30" />
      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8">
        {overline && (
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.7 }} className="overline mb-6 flex items-center gap-3">
            <span className="w-8 h-px bg-cyan-500" />{overline}
          </motion.p>
        )}
        <h1 className="font-display font-black tracking-tighter text-white leading-[0.9] text-[12vw] sm:text-6xl lg:text-7xl max-w-4xl">
          <LineReveal lines={titleLines} delay={0.15} />
        </h1>
        {subtitle && (
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.6, duration: 0.7 }} className="mt-7 max-w-2xl text-lg text-zinc-300 leading-relaxed">
            {subtitle}
          </motion.p>
        )}
        {children && (
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.75, duration: 0.7 }} className="mt-9 flex flex-wrap gap-4">
            {children}
          </motion.div>
        )}
      </div>
    </section>
  );
}
